/**
 * ShapeVariant convention: every stroked SVG primitive (<rect>, <path>,
 * <circle>, <polygon>, <line>, <ellipse>) MUST spread
 * {...SHAPE_STROKE_PROPS} from './stroke-props' so strokes render at
 * uniform width under non-uniform aspect-ratio scaling.
 *
 * The parent SVG in Shape/Component.tsx sets preserveAspectRatio="none"
 * so a 100×100 viewBox stretches to fill the node's actual dimensions.
 * Without vector-effect="non-scaling-stroke", a 200×60 rectangle's
 * left/right edges render ~3× thicker than its top/bottom.
 */

import Rectangle from './rectangle';
import Ellipse from './ellipse';
import Diamond from './diamond';
import Triangle from './triangle';
import Star from './star';
import Pentagon from './pentagon';
import Hexagon from './hexagon';
import Parallelogram from './parallelogram';
import Chevron from './chevron';
import Cross from './cross';
import Cylinder from './cylinder';
import ArrowShape from './arrow-shape';
import Pill from './pill';

export const SHAPE_COMPONENTS = {
  rectangle:    Rectangle,
  // Dimension-aware: receives the node's real px width/height so its caps
  // stay circular. The parent uses a real-pixel viewBox for this kind.
  // Ordered next to rectangle — it's a rounded-rectangle family member.
  pill:         Pill,
  ellipse:      Ellipse,
  diamond:      Diamond,
  triangle:     Triangle,
  star:         Star,
  pentagon:     Pentagon,
  hexagon:      Hexagon,
  parallelogram: Parallelogram,
  chevron:      Chevron,
  cross:        Cross,
  cylinder:     Cylinder,
  'arrow-shape': ArrowShape,
} as const;

/** Derives from the registry — adding a new variant is: create file + add one line above. */
export type ShapeKind = keyof typeof SHAPE_COMPONENTS;
